import ReactECharts from 'echarts-for-react'
import { useFoldData, usePieData } from './util'

const FoldChart = ({design, actually}: {design: any[], actually: any[]}) => {
  const options = useFoldData(design, actually)

  return <ReactECharts option={options} />
}
export default FoldChart